var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0 green lighten-4",attrs:{"fluid":""}},[_c('map-component',{staticStyle:{"height":"100%","position":"relative"},attrs:{"map-id":_vm.mapId,"draw-enabled":true,"marker-labels-permanent":_vm.markerLabelsPermanent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6610aaa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/modules/Map.vue
// module id = 872
// module chunks = 1